import { cn } from '@/lib/utils'
import type { TableShape } from '@/lib/types/table'

interface ShapePickerProps {
  value: TableShape
  onChange: (shape: TableShape) => void
}

const OPTIONS: { shape: TableShape; label: string; width: number; height: number; radius: string }[] = [
  { shape: 'circle',    label: 'Round',     width: 36, height: 36, radius: '50%' },
  { shape: 'square',    label: 'Square',    width: 36, height: 36, radius: '6px' },
  { shape: 'rectangle', label: 'Rectangle', width: 52, height: 32, radius: '6px' },
]

export function ShapePicker({ value, onChange }: ShapePickerProps) {
  return (
    <div>
      <span className="block text-sm text-[var(--color-text-secondary)] mb-2">Shape</span>
      <div className="flex gap-2">
        {OPTIONS.map(({ shape, label, width, height, radius }) => {
          const selected = value === shape
          return (
            <button
              key={shape}
              type="button"
              onClick={() => onChange(shape)}
              className={cn(
                'flex flex-1 flex-col items-center gap-2 py-3 px-2 rounded-[var(--radius-md)] border-2 transition-all duration-150',
                selected
                  ? 'border-[var(--color-accent-amber)] bg-[var(--color-accent-amber-dim)]'
                  : 'border-[var(--color-border-subtle)] bg-[var(--color-bg-elevated)] hover:border-[var(--color-border-default)]',
              )}
            >
              <div
                style={{
                  width,
                  height,
                  borderRadius: radius,
                  backgroundColor: selected
                    ? 'var(--color-accent-amber)'
                    : 'var(--color-bg-overlay)',
                  border: `2px solid ${selected ? 'var(--color-accent-amber)' : 'var(--color-border-default)'}`,
                  flexShrink: 0,
                }}
              />
              <span className={cn(
                'text-[10px] font-medium',
                selected ? 'text-[var(--color-accent-amber)]' : 'text-[var(--color-text-muted)]',
              )}>
                {label}
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
